import React, { useState } from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Industries(props) {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";

  return (
    <div className="seriveces_industries p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
            <div className="example" data-text="We Serve">
              <h2>Industries We Serve</h2>
            </div>
            <p className="strong">
              Tekrevol helps startups and enterprises utilize modern
              technologies to stay ahead of the market. We bestowed to serve a
              diverse range of industries and offer customized technological
              solutions and cloud computing consultant services to meet the
              needs of every sector.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="deskstop_version"
          >
            <div className="process_icons">
              <ul>
                <li
                  className={`tabs ${getActiveClass(1, "active-tabs")}`}
                  onClick={() => toggleTab(1)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                  </div>
                  Healthcare
                </li>
                <li
                  className={`tabs ${getActiveClass(2, "active-tabs")}`}
                  onClick={() => toggleTab(2)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                  </div>
                  Real Estate
                </li>

                <li
                  className={`tabs ${getActiveClass(3, "active-tabs")}`}
                  onClick={() => toggleTab(3)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                  </div>
                  Gaming
                </li>
                <li
                  className={`tabs ${getActiveClass(4, "active-tabs")}`}
                  onClick={() => toggleTab(4)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                  </div>
                  Ecommerce
                </li>
                <li
                  className={`tabs ${getActiveClass(5, "active-tabs")}`}
                  onClick={() => toggleTab(5)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                  </div>
                  Lifestyle
                </li>
              </ul>

              <div
                className={
                  toggleState === 1 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  Our Managed Cloud Services provide rigorous security
                  safeguards and regulatory compliance support, ensuring that
                  sensitive patient information is always safeguarded.
                  Healthcare firms can use scalable infrastructure to
                  efficiently handle electronic health records (EHR), streamline
                  operations, and improve patient care delivery.
                </p>
              </div>
              <div
                className={
                  toggleState === 2 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  We offer dependable and budget-friendly infrastructure
                  solutions that are customized to the particular requirements
                  of the real estate industry. Our cloud services enable real
                  estate companies to provide outstanding experiences to
                  customers, sellers, and brokers alike, from managing peak
                  traffic during property searches to smoothly integrating
                  third-party services.
                </p>
              </div>
              <div
                className={
                  toggleState === 3 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  The gaming industry requires high-performance infrastructure
                  to provide immersive gaming experiences while also managing
                  large numbers of concurrent users. Our managed cloud services
                  provide the flexibility and scalability required to meet the
                  ever-changing needs of the gaming industry.
                </p>
              </div>
              <div
                className={
                  toggleState === 4 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  We offer a wide range of solutions that are adapted to the
                  constantly changing needs of e-commerce platforms. Our cloud
                  services provide your e-commerce website with the flexibility
                  and scalability it needs to effortlessly manage variable
                  traffic, ensuring it is always responsive and available to
                  customers.
                </p>
              </div>
              <div
                className={
                  toggleState === 5 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  Our cloud services help lifestyle companies grow their
                  clientele, accelerate market trends, and enhance staff
                  productivity. Whether it's taking care of reservations and
                  bookings, managing online shops, or providing individualized
                  customer experiences, our Managed Cloud Services offer custom
                  solutions to match the specific needs of lifestyle brands.
                </p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mobile_version"
          >
            <div className="tekrevol_mobile_accordion_side">
              <Accordion defaultActiveKey="1">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                    Healthcare
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Our Managed Cloud Services provide rigorous security
                      safeguards and regulatory compliance support, ensuring
                      that sensitive patient information is always safeguarded.
                      Healthcare firms can use scalable infrastructure to
                      efficiently handle electronic health records (EHR),
                      streamline operations, and improve patient care delivery.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                    Real Estate
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      We offer dependable and budget-friendly infrastructure
                      solutions that are customized to the particular
                      requirements of the real estate industry. Our cloud
                      services enable real estate companies to provide
                      outstanding experiences to customers, sellers, and brokers
                      alike, from managing peak traffic during property searches
                      to smoothly integrating third-party services.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                    Gaming
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The gaming industry requires high-performance
                      infrastructure to provide immersive gaming experiences
                      while also managing large numbers of concurrent users. Our
                      managed cloud services provide the flexibility and
                      scalability required to meet the ever-changing needs of
                      the gaming industry.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                    Ecommerce
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      We offer a wide range of solutions that are adapted to the
                      constantly changing needs of e-commerce platforms. Our
                      cloud services provide your e-commerce website with the
                      flexibility and scalability it needs to effortlessly
                      manage variable traffic, ensuring it is always responsive
                      and available to customers.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                    Lifestyle
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Our cloud services help lifestyle companies grow their
                      clientele, accelerate market trends, and enhance staff
                      productivity. Whether it's taking care of reservations and
                      bookings, managing online shops, or providing
                      individualized customer experiences, our Managed Cloud
                      Services offer custom solutions to match the specific
                      needs of lifestyle brands.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Industries;
